import { render, staticRenderFns } from "./NewsCategoryEntity.vue?vue&type=template&id=70be314a&"
import script from "./NewsCategoryEntity.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports